import { gql, useMutation } from "@apollo/client";
import { Box, Button, Flex, HStack, useToast } from "@chakra-ui/react";
import { useState } from "react";
import { Form } from "react-final-form";
import useGravityForms from "../../hooks/use-gravity-forms";
import { prepareGformFields } from "../../support/gravity-forms-helper";
import { wpStyles } from "../../theme/wp-styles";
import GravityFormsField from "./GravityFormFields";
import parse from "html-react-parser";
import TagManager from "react-gtm-module";
import useSite from "../../hooks/use-site";

const fieldWidth = {
  1: "100%",
  3: "25%",
  4: "33.33333%",
  6: "50%",
  12: "100%",
};

const SUBMIT_FORM = gql`
  mutation submitGfForm(
    $databaseId: ID!
    $fieldValues: [FormFieldValuesInput]!
  ) {
    submitGfForm(input: { id: $databaseId, fieldValues: $fieldValues }) {
      confirmation {
        type
        message
        url
      }
      entry {
        id
      }
      errors {
        id
        message
      }
    }
  }
`;

const GravityFormsForm = () => {
  const { fields, submit, formId, formFileUploads } = useGravityForms();

  const [hasSubmitted, setHasSubmitted] = useState(false);

  const [successMessage, setSuccessMessage] = useState("");

  const [submitForm, { data, loading, error }] = useMutation(SUBMIT_FORM);

  const toast = useToast();

  let initialValues = {};
  fields.map(
    ({ id, value }) => (initialValues[`id_${id}`] = value ? value : "")
  );
  return (
    <>
      {!hasSubmitted ? (
        <Form
          initialValues={initialValues}
          mutators={{
            setValue: ([field, value], state, { changeValue }) => {
              changeValue(state, field, () => value);
            },
          }}
          onSubmit={(values) => {
            const formValues = prepareGformFields(
              fields,
              values,
              formFileUploads
            );
            console.log("Form Values", formValues);
            submitForm({
              variables: {
                databaseId: formId,
                fieldValues: formValues,
              },
            })
              .then((data) => {
                console.log("Form Submit Response", data);
                const {
                  data: {
                    submitGfForm: {
                      confirmation: { message, type, url },
                    },
                  },
                } = data;

                if (type === "MESSAGE" && message) {
                  setSuccessMessage(message);
                }
                if (formId === 1) {
                  TagManager.dataLayer({
                    gtmId: process.env.NEXT_PUBLIC_GTM_CONTAINER,
                    dataLayer: {
                      event: "form_fill",
                    },
                  });
                }

                toast({
                  title: "Success!",
                  description: "Your submission has been received!",
                  status: "success",
                  duration: 8000,
                  isClosable: true,
                  containerStyle: {
                    fontSize: wpStyles.fontSize.sm,
                  },
                });
                setHasSubmitted(true);
              })
              .catch((error) => {
                console.log(error);
                toast({
                  title: "Error",
                  description: "We had an error submitting your form request.",
                  status: "error",
                  duration: 8000,
                  isClosable: true,
                  containerStyle: {
                    fontSize: wpStyles.fontSize.sm,
                  },
                });
              });
          }}
          render={({ handleSubmit, submitting, pristine, values }) => (
            <form onSubmit={handleSubmit}>
              <Flex wrap="wrap" mx={["0", "0", -4]}>
                {fields.map((field) => (
                  <Box
                    my={3}
                    px={[0, 0, 4]}
                    w={[
                      "100%",
                      "100%",
                      `${fieldWidth[field.layoutGridColumnSpan]}`,
                    ]}
                    key={field.id}
                  >
                    <GravityFormsField field={field} />
                  </Box>
                ))}
              </Flex>
              <HStack justify="flex-end">
                <Box>
                  <Button
                    mt={4}
                    w={[
                      "100%",
                      "100%",
                      `${fieldWidth[submit.layoutGridColumnSpan]}`,
                    ]}
                    px={12}
                    variant="solid"
                    isLoading={submitting}
                    isDisabled={submitting}
                    type="submit"
                    colorScheme="blackAlpha"
                    borderRadius="md"
                    fontWeight="normal"
                  >
                    {submit.text ? submit.text : "Submit"}
                  </Button>
                </Box>
              </HStack>
            </form>
          )}
        />
      ) : (
        <Box textAlign="center">
          {successMessage ? parse(successMessage) : "Form has been received!"}
        </Box>
      )}
    </>
  );
};

export default GravityFormsForm;
